import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {ImagePopupService} from '../../../shared/image-popup/image-popup.service';

@Component({
  selector: 'elastic-livery-showroom',
  templateUrl: './livery-showroom.component.html',
  styleUrls: ['./livery-showroom.component.scss']
})
export class LiveryShowroomComponent implements OnInit {
  @Input() teamId: any = 0;
  @Input() userId: any = 0;

  liveries: [];

  selectedSim: any;

  constructor(private globalService: GlobalService, private cdr: ChangeDetectorRef, private imagePopup: ImagePopupService) { }

  ngOnInit() {
    this.selectedSim = this.globalService.getActiveSim();
    this.getData();
  }

  getData() {
    if (this.teamId > 0) {
      this.globalService.getTeamLiveries(this.teamId).subscribe( (data: any) => {
        if (data) {
          this.liveries = data;
          this.cdr.detectChanges();
        }
      });
    } else {
      this.globalService.getSpecificUsersLiveries(this.userId).subscribe( (data: any) => {
        if (data) {
          this.liveries = data;
          this.cdr.detectChanges();
        }
      });
    }

  }


}
